import React from "react";

const Terms = () => {
  return (
    <div className="min-h-screen bg-gray-100 flex flex-col">
      <main className="flex-grow py-12 px-4">
        <div
          className="max-w-4xl mx-auto bg-white p-10 shadow-xl rounded-xl text-gray-800 text-[21px]">
          <h1 className="text-4xl font-bold mb-2 border-l-4 border-blue-600 pl-4">
            Terms and Conditions
          </h1>
          <p className="text-sm text-gray-500 mb-10 text-right">
            Last updated: May 14, 2025
          </p>

          <div className="space-y-10 leading-relaxed">
            <section>
              <h2 className="text-2xl font-semibold mb-2">1. Introduction</h2>
              <p>
                Welcome to Iword Hosting ("Company", "we", "our", or "us"). These
                Terms of Service ("Terms") govern your use of our website
                <a href="https://i-word.net" className="text-blue-600 underline"> https://i-word.net</a> and all associated
                hosting, domain, and support services (collectively, the "Services").
                By accessing or using our Services, you agree to be bound by these Terms.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-2">2. Services Provided</h2>
              <p>
                Iword Hosting provides shared hosting, reseller hosting, VPS, domain
                registration, SSL certificates, and technical support. All services are
                offered “as is” and “as available.” We do not guarantee uninterrupted
                service, but we target 99.9% uptime across our infrastructure.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-2">3. Billing and Payments</h2>
              <p>
                Services are billed in advance on a recurring basis unless otherwise
                stated. You authorize Iword Hosting to automatically charge your
                payment method at the beginning of each billing cycle. Domain and SSL
                purchases are non-refundable.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-2">4. Acceptable Use</h2>
              <ul className="list-disc pl-6 space-y-1">
                <li>No spam, phishing, or malware distribution</li>
                <li>No illegal content (including pirated software, CSAM, etc.)</li>
                <li>No resource abuse (CPU/memory overuse on shared plans)</li>
                <li>No attempts to hack, exploit, or access other accounts or services</li>
              </ul>
              <p className="mt-2">
                We reserve the right to suspend or terminate accounts that violate our
                Acceptable Use Policy without notice or refund.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-2">5. Backups and Data</h2>
              <p>
                While we may run routine server-level backups, customers are responsible
                for maintaining backups of their own data. Iword Hosting is not liable
                for data loss due to account termination, server failure, or user error.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-2">6. Domain Registration</h2>
              <p>
                Domains registered through Iword Hosting are processed via third-party
                registrars such as Enom. You agree to be bound by the registrar’s own
                terms of service. Renewal notices will be sent to the email on file.
                Failure to renew domains before expiration may result in permanent loss.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-2">7. Termination</h2>
              <p>
                You may cancel your account at any time via your client portal. We
                reserve the right to terminate accounts for non-payment or abuse. Upon
                cancellation, all data may be deleted immediately and is unrecoverable.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-2">8. Liability</h2>
              <p>
                Iword Hosting shall not be liable for indirect, incidental, or
                consequential damages, including but not limited to data loss, business
                interruption, or lost profits.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-2">9. Changes to Terms</h2>
              <p>
                We may update these Terms at any time. Changes will take effect once
                posted to this page. Continued use of our Services after updates means
                you agree to the revised Terms.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-2">10. Contact Us</h2>
              <p>
                If you have questions about these Terms, please contact us:
              </p>
              <ul className="list-disc pl-6 mt-2">
                <li>Email: <a href="mailto:support@i-word.net" className="text-blue-600 underline">support@i-word.net</a></li>
                <li>Web: <a href="https://i-word.net/contact" className="text-blue-600 underline">https://i-word.net/contact</a></li>
                <li>Privacy Policy: <a href="/privacy" className="text-blue-600 underline">/privacy</a></li>
              </ul>
            </section>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Terms;

